import http from '@/assets/js/interceptor';
import util from '@/assets/js/util';
// 获取列表
export function getTempGroupList (filter) {
  return http.get('/tplGroup/selectPage', { params: filter, domainType: 'bpmApi' });
}
// 导出列表
export function exportTempGroupList (params, fileName) {
  return util.fileDownloadBydomanType({ fileName, ajax: http, url: '/tplGroup/export', params, domainType: 'bpmApi' });
}
// 禁用
export function disableStatus (id) {
  return http.delete(`/tplGroup/disable/${id}`, { domainType: 'bpmApi' });
}
// 启用
export function enableStatus (id) {
  return http.put(`/tplGroup/enable/${id}`, {}, { domainType: 'bpmApi' });
}
export function getSortMax () {
  return http.get('/tplGroup/getSort', { domainType: 'bpmApi' });
}
// 创建模版组
export function createTempGroup (data) {
  return http.post('/tplGroup/insert', data, { domainType: 'bpmApi' });
}
// 编辑模版组
export function editTempGroup (data) {
  return http.put('/tplGroup/update', data, { domainType: 'bpmApi' });
}
// 获取模版组详情
export function getTempGroupDetail (id) {
  return http.get(`/tplGroup/detail/${id}`, { domainType: 'bpmApi' });
}
